import { render } from "./topicManager.vue?vue&type=template&id=60a3eef0&scoped=true"
import script from "./topicManager.vue?vue&type=script&lang=js"
export * from "./topicManager.vue?vue&type=script&lang=js"

import "./topicManager.vue?vue&type=style&index=0&id=60a3eef0&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a3eef0"]])

export default __exports__